module.exports = __webpack_public_path__ + "static/img/SRGLogo_full_color_2022.a897a9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SRGLogo_full_color_2022.svg
// module id = lA2l
// module chunks = 0